module.exports = {
	asteroidsJellies : require("./asteroidsJellies"),
	titles : require("./titles"),
	intro : require("./intro"),
	web : require("./web"),
	// vortex : require("./vortex")
};
